import Cookies from 'js-cookie';

const isProd = process.env.NODE_ENV === 'production';

export const storage = {
  get(key: string) {
    if (typeof window === 'undefined') return null;
    return Cookies.get(key) || null;
  },

  set(key: string, value: string) {
    if (typeof window === 'undefined') return false;

    Cookies.set(key, value, {
      expires: 30,
      path: '/',
      sameSite: isProd ? 'None' : 'Lax',
      secure: isProd, // MUST be true for HTTPS domain
    });

    return true;
  },

  remove(key: string) {
    if (typeof window === 'undefined') return false;

    Cookies.remove(key, {
      path: '/',
      secure: isProd,
      sameSite: isProd ? 'None' : 'Lax',
    });

    return true;
  },

  clear() {
    if (typeof window === 'undefined') return false;
    const all = Cookies.get();

    Object.keys(all).forEach((cookieName) =>
      Cookies.remove(cookieName, {
        path: '/',
        secure: isProd,
        sameSite: isProd ? 'None' : 'Lax',
      })
    );

    return true;
  },
};

export function getToken() {
  if (typeof window === 'undefined') return null;
  return storage.get('token');
}

export function removeToken() {
  if (typeof window === 'undefined') return false;
  storage.remove('token');
  storage.remove('refresh_token');
  return true;
}

export const isAuthenticated = () => {
  return !!getToken(); // token exists = user is logged in
};
